import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cars: [
    {
      name: "Model S",
      link: "model-s",
    },
    {
      name: "Model Y",
      link: "model-y",
    },

    {
      name: "Model 3",
      link: "model-3",
    },
    {
      name: "Model X",
      link: "model-x",
    },

    {
      name: "Solar Roofs",
      link: "solar-roofs",
    },
    {
      name: "Solar Panels",
      link: "solar-panels",
    },
  ],
};

export const carSlice = createSlice({
  name: "car",
  initialState,
  reducers: {},
});

// export const carSelector = (state) => state.car.cars;

export default carSlice.reducer;
